import { styled } from '@glitz/react';
import { type ThemeType } from 'webapp/theme';

export function createBorderDecorator(as: ThemeType, border = true) {
  return border
    ? styled({
        border: { xy: { width: 1, style: 'solid', color: t => t[as].border } },
      })
    : styled();
}
